import {
  DropdownType,
  ReportType,
  SelectionType,
  State
} from "@/enums";
import { convertEnumerationToObject } from "@/utilities";

export const dropdownTypes = convertEnumerationToObject(DropdownType);
export const reportTypes = convertEnumerationToObject(ReportType);
export const selectionTypes = convertEnumerationToObject(SelectionType);
export const states = convertEnumerationToObject(State);

export default {
  dropdownTypes,
  reportTypes,
  selectionTypes,
  states,
}

